import axios from "axios";

export default axios.create({
  baseURL: "https://lms.aeonsoftware.net/cit/",
});